import React from "react";

import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components/macro";

import { setSetting } from "actions";

import { LinkButton } from "components/Form";
import { Dialog, DialogTitle } from "components/MaterialDialog";

import { ModalTypes } from "constants/navigation";
import { Settings } from "constants/settings";

import { getContextByModalType, getSetting } from "selectors";

import { useCounter } from "hooks";

import {
  FilterSetting,
  FilterSettings,
  FilterState,
} from "reducers/settings/types";
import { ModalContent } from "./ModalContent";

const DialogTitleButtons = styled.span(
  ({ theme: { fontSizes, fontWeights, space } }) => `
  font-size: ${fontSizes.charlie}px;
  font-weight: ${fontWeights.normal};
  display: inline-flex;
  grid-gap: ${space[2]}px;
  padding: 0 ${space[2]}px;
`,
);

interface AdapterProps {
  onClose: () => void;
}

export function FilterModalAdapter(props: AdapterProps): React.JSX.Element {
  const { onClose } = props;

  const context = useSelector(getContextByModalType(ModalTypes.Filter)) || {};
  const filterState: FilterState =
    useSelector(getSetting(Settings.filter)) || {};
  const { filterSettings = [] }: FilterState = filterState;

  const { isOpen, filterIds } = context;

  const dispatch = useDispatch();
  const [key, invalidateKey] = useCounter();

  function onClickClearAll(): void {
    const newFilterSettings: FilterSettings = filterSettings.filter(
      (filterSetting: FilterSetting) => !filterIds.includes(filterSetting.id),
    );
    const newFilterState: FilterState = {
      ...filterState,
      filterSettings: newFilterSettings,
    };
    dispatch(setSetting(Settings.filter, newFilterState));
    invalidateKey();
  }

  return (
    <Dialog open={isOpen && filterIds} onClose={onClose} maxWidth="md">
      <DialogTitle onClose={onClose}>
        Filter
        <DialogTitleButtons>
          <LinkButton onClick={onClickClearAll} type="button">
            Clear all
          </LinkButton>
        </DialogTitleButtons>
      </DialogTitle>
      <ModalContent filterIds={filterIds} onClose={onClose} key={key} />
    </Dialog>
  );
}
